module.exports = __webpack_public_path__ + "media/assets/img/slider/04-142989c0de8605d2de491923d868e707.jpg";